import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { RootState } from "../../store/store";
import { Typography } from "@material-tailwind/react";
import moment from "moment";
import { AllBookingList } from "../../store/BookingSlice";
import { AllBookingLists } from "../../interfaces/BookingList";

const ListView = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<any>();

  const TABLE_HEAD = [
    t("adminBookings.table.title", "TITLE"),
    t("adminBookings.table.patientName", "PATIENT NAME"),
    t("adminBookings.table.amount", "AMOUNT"),
    t("adminBookings.table.bookingDate", "BOOKING DATE"),
    t("adminBookings.table.acknowledgementNumber", "ACKNOWLEDGEMENT NUMBER"),
  ];

  useEffect(() => {
    dispatch(AllBookingList());
  }, [dispatch]);

  const BookingAll = useSelector((state: RootState) => {
    const bookingData = state.booking.data;
    if (!bookingData) {
      return [] as unknown as AllBookingLists[];
    }
    return bookingData as unknown as AllBookingLists[];
  });

  return (
    <div className="w-full h-full flex flex-col overflow-hidden">
      <div className="w-full h-full overflow-x-auto overflow-y-auto">
        <table className="w-full min-w-[700px] table-auto text-left">
          <thead className="sticky top-0 bg-white z-10">
            <tr className="bg-[#F8F9FA] text-left border-b-2 border-gray-100">
              {TABLE_HEAD.map((head, i) => (
                <th
                  key={i}
                  className="py-4 px-6 font-bold text-[#7E8299] uppercase text-xs whitespace-nowrap"
                >
                  <Typography
                    variant="small"
                    className="font-semibold leading-none text-[#7E8299] opacity-70 whitespace-nowrap"
                  >
                    {head}
                  </Typography>
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {!BookingAll || BookingAll.length === 0 ? (
              <tr>
                <td colSpan={5} className="text-center py-12 text-gray-500 font-medium">
                  {t("adminBookings.noBookings", "No bookings found")}
                </td>
              </tr>
            ) : (
              BookingAll.map((booking, index) => (
                <tr key={booking.id || index} className="hover:bg-gray-50/50 transition-colors">
                  <td className="py-4 px-6 whitespace-nowrap">
                    <Typography
                      variant="small"
                      color="black"
                      className="font-medium"
                    >
                      {booking?.program?.title || "-"}
                    </Typography>
                  </td>
                  <td className="py-4 px-6 whitespace-nowrap">
                    <Typography
                      variant="small"
                      color="black"
                      className="font-medium"
                    >
                      {booking?.patient?.fullName || "-"}
                    </Typography>
                  </td>
                  <td className="py-4 px-6 whitespace-nowrap">
                    <Typography
                      variant="small"
                      color="black"
                      className="font-medium"
                    >
                      {booking?.amount != null ? `$ ${booking.amount}` : "-"}
                    </Typography>
                  </td>
                  <td className="py-4 px-6 whitespace-nowrap">
                    <Typography
                      variant="small"
                      color="black"
                      className="font-medium"
                    >
                      {booking?.paymentDate
                        ? moment(booking.paymentDate).format("DD MMM, YYYY")
                        : "-"}
                    </Typography>
                  </td>
                  <td className="py-4 px-6 whitespace-nowrap">
                    <Typography
                      variant="small"
                      color="black"
                      className="font-medium"
                    >
                      {booking?.paymentReferenceId || "-"}
                    </Typography>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ListView;
